module.exports = __webpack_public_path__ + "static/media/02.a3554657.svg";